
<div class="card">
  <div class="card-header card-header-grey">
    <h4 class="card-title">
      Modifier mon profil
    </h4>
  </div>
  <br />
  <mat-tab-group color="accent">
    <!-- Doonées personelles :
    - Nom
    - Prénom
    - Mail
    - Date de Naissance
    -->
    <mat-tab label="Données personnelles">
      <div class="row" style="margin-top:2rem;">
        <div class="col-md-12">
          <form>
            <div class="row">
              <div class="col-md-6" *ngIf="isAffich('civilite')">
                <mat-form-field [color]="param.color" appearance="legacy">
                  <mat-label>Civilité</mat-label>
                  <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="_civilite" id="civilite" name="civilite" (ngModelChange)="onSubmitField()">
                    <mat-option value="">À Préciser</mat-option>
                    <mat-option value="Madame">Madame</mat-option>
                    <mat-option value="Monsieur">Monsieur</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div #name class="col-md-6" *ngIf="isAffich('nom')">
                <mat-form-field [color]="param.color">
                  <mat-label>Nom</mat-label>
                  <input type="text" matInput value="{{ _nom }}" name="nom" [(ngModel)]='_nom' placeholder="Martin" (ngModelChange)="onSave('can_nom', $event)" #nom>
                  <!--<button id="edit-name" mat-icon-button matSuffix (click)="onClick($event);lastValue=_nom" *ngIf="selected !== 'edit-name'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
                  <button id="valid-name" mat-icon-button matSuffix *ngIf="selected == 'edit-name'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-name" mat-icon-button (click)="onClear();_nom=lastValue" matSuffix *ngIf="selected == 'edit-name'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="isAffich('prenom')">
                <mat-form-field [color]="param.color">
                  <mat-label>Prénom</mat-label>
                  <input type="text" matInput value="{{ _prenom }}" name="prenom" [(ngModel)]='_prenom' placeholder="Jérémy" (ngModelChange)="onSave('can_prenom', $event)" #prenom>
                  <!--<button id="edit-prenom" mat-icon-button matSuffix (click)="onClick($event);lastValue=_prenom" *ngIf="selected !== 'edit-prenom'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
                  <button id="valid-prenom" mat-icon-button matSuffix *ngIf="selected == 'edit-prenom'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-prenom" mat-icon-button (click)="onClear();_prenom=lastValue" matSuffix *ngIf="selected == 'edit-prenom'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" *ngIf="isAffich('mail')">
                <mat-form-field [color]="param.color">
                  <mat-label>Adresse mail</mat-label>
                  <input type="email" matInput value="{{ _mail }}" name="mail" [pattern]="emailPattern" [(ngModel)]='_mail' placeholder="myname@test.fr" (ngModelChange)="onSave('can_mail', $event)" #email="ngModel">
                  <!--<button id="edit-mail" mat-icon-button matSuffix (click)="onClick($event);lastValue=_mail" *ngIf="selected !== 'edit-mail'">
                    <div class="icon"><mat-icon>edit</mat-icon></div>
                  </button>
                  <button id="valid-mail" mat-icon-button matSuffix [disabled]="email.errors?.pattern" *ngIf="selected == 'edit-mail'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-mail" mat-icon-button (click)="onClear();_mail=lastValue" matSuffix *ngIf="selected == 'edit-mail'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>

              <div class="col-md-6" *ngIf="isAffich('mail')">
                <mat-form-field [color]="param.color">
                  <mat-label>Adresse mail 2</mat-label>
                  <input type="email" matInput value="{{ _mail2 }}" name="mail" [pattern]="emailPattern" [(ngModel)]='_mail2' placeholder="myname@test.fr" (ngModelChange)="onSave('can_mail3', $event)" #email2="ngModel">
                  <!--<button id="edit-mail2" mat-icon-button matSuffix (click)="onClick($event);lastValue=_mail2" *ngIf="selected !== 'edit-mail2'">
                    <div class="icon"><mat-icon>edit</mat-icon></div>
                  </button>
                  <button id="valid-mail2" mat-icon-button matSuffix [disabled]="email2.errors?.pattern" *ngIf="selected == 'edit-mail2'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-mail2" mat-icon-button (click)="onClear();_mail2=lastValue" matSuffix *ngIf="selected == 'edit-mail2'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6" *ngIf="isAffich('naissance')">
                <mat-form-field [color]="param.color">
                  <mat-label>Date de naissance</mat-label>
                  <input matInput [matDatepicker]="picker1" name="naissance" [(ngModel)]="_naissance" (ngModelChange)="onSave('can_date_naissance', $event)">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                  <!--<button id="edit-naissance" mat-icon-button matSuffix (click)="onClick($event);lastValue=_naissance.toString()" *ngIf="selected !== 'edit-naissance'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
                  <button id="valid-naissance" mat-icon-button matSuffix *ngIf="selected == 'edit-naissance'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-naissance" mat-icon-button (click)="onClear();lastDateNais();" matSuffix *ngIf="selected == 'edit-naissance'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </div>
    </mat-tab>

    <!-- Cordonées:
    - Adresse
    - Ville
    - Code Postal
    - Pays
    - Téléphone fixe
    - Téléphone mobile
    - Permis de conduire
    - Véhicule ?

    DEBUT CATEGORIE
    -->
    <mat-tab label="Coordonnées">
      <div class="row" style="margin-top:2rem;">
        <div class="col-12">
          <form>
            <div class="row">
              <div class="col-md-6" *ngIf="isAffich('adresse')">
                <mat-form-field [color]="param.color">
                  <mat-label>Adresse</mat-label>
                  <input type="text" matInput id="adresse" [(ngModel)]="_adresse" name="adresse" placeholder="ex: 9 Rue Adresse" (ngModelChange)="onSave('can_adresse1', $event)" #adresse>
                  <!--<button id="edit-adresse" mat-icon-button matSuffix (click)="onClick($event);lastValue=_adresse" *ngIf="selected !== 'edit-adresse'">
                    <div class="icon"><mat-icon>edit</mat-icon></div>
                  </button>
                  <button id="valid-adresse" mat-icon-button matSuffix *ngIf="selected == 'edit-adresse'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-adresse" mat-icon-button (click)="onClear();_adresse=lastValue" matSuffix *ngIf="selected == 'edit-adresse'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="isAffich('ville')">
                <mat-form-field [color]="param.color">
                  <mat-label>Ville</mat-label>
                  <input type="text" matInput id="ville" [(ngModel)]="_ville" name="ville" placeholder="" (ngModelChange)="onSave('can_ville', $event)" #ville>
                  <!--<button id="edit-ville" mat-icon-button matSuffix (click)="onClick($event);lastValue=_ville" *ngIf="selected !== 'edit-ville'">
                    <div class="icon"><mat-icon>edit</mat-icon></div>
                  </button>
                  <button id="valid-ville" mat-icon-button matSuffix *ngIf="selected == 'edit-ville'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-ville" mat-icon-button (click)="onClear();_ville=lastValue" matSuffix *ngIf="selected == 'edit-ville'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" *ngIf="isAffich('postal')">
                <mat-form-field [color]="param.color">
                  <mat-label>Code Postal</mat-label>
                  <input type="text" [(ngModel)]="_codepostal" [pattern]="postalPattern" matInput id="code_postal" name="code_postal" placeholder="ex: 31400" (ngModelChange)="onSave('can_codepostal', $event)" #code_postal="ngModel">
                  <!--<button id="edit-postal" mat-icon-button matSuffix (click)="onClick($event);lastValue=_codepostal" *ngIf="selected !== 'edit-postal'">
                    <div class="icon"><mat-icon>edit</mat-icon></div>
                  </button>
                  <button id="valid-postal" mat-icon-button matSuffix [disabled]="code_postal.errors?.pattern" *ngIf="selected == 'edit-postal'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-postal" mat-icon-button (click)="onClear();_codepostal=lastValue;" matSuffix *ngIf="selected == 'edit-postal'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="isAffich('pays')">
                <mat-form-field [color]="param.color">
                  <mat-label>Pays</mat-label>
                  <input type="text" matInput id="pays" [(ngModel)]="_pays" name="pays" placeholder="" (ngModelChange)="onSave('can_pays', $event)" #pays>
                  <!--<button id="edit-pays" mat-icon-button matSuffix (click)="onClick($event);lastValue=_pays" *ngIf="selected !== 'edit-pays'">
                    <div class="icon"><mat-icon>edit</mat-icon></div>
                  </button>
                  <button id="valid-pays" mat-icon-button matSuffix *ngIf="selected == 'edit-pays'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-pays" mat-icon-button (click)="onClear();_pays=lastValue" matSuffix *ngIf="selected == 'edit-pays'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6" *ngIf="isAffich('tel_fixe')">
                <mat-form-field [color]="param.color">
                  <mat-label>Téléphone fixe</mat-label>
                  <input type="text" matInput value="{{ _fixe }}" [pattern]="phoneNumber" name="domicile" [(ngModel)]='_fixe' placeholder="0102030405" (ngModelChange)="onSave('can_tel_dom', $event)" #fixe="ngModel">
                  <!--<button id="edit-fixe" mat-icon-button matSuffix (click)="onClick($event);lastValue=_fixe;" *ngIf="selected !== 'edit-fixe'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
                  <button id="valid-fixe" mat-icon-button matSuffix [disabled]="fixe.errors?.pattern" *ngIf="selected == 'edit-fixe'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-fixe" mat-icon-button (click)="onClear();_fixe=lastValue;" matSuffix *ngIf="selected == 'edit-fixe'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="isAffich('tel_portable')">
                <mat-form-field [color]="param.color">
                  <mat-label>Téléphone portable</mat-label>
                  <input type="text" matInput value="{{ _portable }}" [pattern]="phoneNumber" name="portable" [(ngModel)]='_portable' placeholder="0607080901" (ngModelChange)="onSave('can_tel_mob', $event)" #portable="ngModel">
                  <!--<button id="edit-portable" mat-icon-button matSuffix (click)="onClick($event);lastValue=_portable;" *ngIf="selected !== 'edit-portable'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
                  <button id="valid-portable" mat-icon-button matSuffix [disabled]="portable.errors?.pattern" *ngIf="selected == 'edit-portable'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-portable" mat-icon-button (click)="onClear();_portable=lastValue;" matSuffix *ngIf="selected == 'edit-portable'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
              <div class="col-md-6" *ngIf="isAffich('tel_portable')">
                <mat-form-field [color]="param.color">
                  <mat-label>Profil LinkedIn</mat-label>
                  <input type="text" matInput value="{{ _reseaux }}" name="reseaux" [(ngModel)]='_reseaux' (ngModelChange)="onSave('can_web', $event)">
                  <!--<button id="edit-reseau" mat-icon-button matSuffix (click)="onClick($event);lastValue=_portable;" *ngIf="selected !== 'edit-reseau'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
                  <button id="valid-reseau" mat-icon-button matSuffix *ngIf="selected == 'edit-reseau'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                  <button id="clear-reseau" mat-icon-button (click)="onClear();_portable=lastValue;" matSuffix *ngIf="selected == 'edit-reseau'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
                </mat-form-field>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-md-6" *ngIf="isAffich('permis')">
                <mat-label>Permis de conduire</mat-label>
                <!--<button id="edit-permis" mat-icon-button matSuffix (click)="onClick($event)" *ngIf="selected !== 'edit-permis'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
                <button id="valid-permis" mat-icon-button matSuffix *ngIf="selected == 'edit-permis'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                <button id="clear-permis" mat-icon-button (click)="onClear()" matSuffix *ngIf="selected == 'edit-permis'"><div class="icon"><mat-icon>clear</mat-icon></div></button>
                <br />-->
                <mat-radio-group [(ngModel)]="_permis" id="permis" name="permis" aria-label="Select an option" (ngModelChange)="onSave('can_permis', $event)" #permis>
                  <mat-radio-button class="ml-2" [value]="true"> Oui</mat-radio-button>
                  &nbsp;&nbsp;
                  <mat-radio-button [value]="false"> Non</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="col-md-6" *ngIf="isAffich('vehicule')">
                <mat-label>Possédez vous un véhicule ?</mat-label>
                <!--<button id="edit-vehicule" mat-icon-button matSuffix (click)="onClick($event)" *ngIf="selected !== 'edit-vehicule'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
                <button id="valid-vehicule" mat-icon-button matSuffix *ngIf="selected == 'edit-vehicule'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
                <button id="clear-vehicule" mat-icon-button (click)="onClear()" matSuffix *ngIf="selected == 'edit-vehicule'"><div class="icon"><mat-icon>clear</mat-icon></div></button>
                <br />-->
                <mat-radio-group id="vehicule" [(ngModel)]="_vehicule" name="vehicule" (ngModelChange)="onSave('can_voiture', $event)" aria-label="Select an option" #vehicule>
                  <mat-radio-button class="ml-2" value="o"> Oui</mat-radio-button>
                  &nbsp;&nbsp;
                  <mat-radio-button value="n"> Non</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </form>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Handicap">
      <div class="row mt-4 mb-4">
        <div class="col-md-12">
          <mat-label class="mr-2">Souhaitez-vous signifier à l'entreprise une situation de handicap ?</mat-label>
          <!--<button id="valid-handicap" mat-icon-button matSuffix *ngIf="isChecked" (click)="onSubmitField();lastChecked=isChecked"><div class="icon"><mat-icon>done</mat-icon></div></button>
          <button id="clear-handicap" mat-icon-button (click)="onClear();isChecked=false;onSubmitField();isChecked=lastChecked" matSuffix *ngIf="isChecked"><div class="icon"><mat-icon>clear</mat-icon></div></button>
          <br/>-->
          <mat-slide-toggle [(ngModel)]="isChecked" (ngModelChange)="onSave('can_handicap', $event)"></mat-slide-toggle>
          <!--<br/>
          <br/>-->
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" [hidden]="!isChecked">
          <mat-form-field [color]="param.color" appearance="outline">
            <mat-label>Nous vous invitons si vous le souhaitez, à nous informer des conséquences de votre handicap</mat-label>
            <textarea [(ngModel)]="description" (ngModelChange)="onSave('can_handicap_consequence', $event)" type="text" rows="5" cols="40" matInput maxlength="1000" name="description"></textarea>
          </mat-form-field>
        </div>
        <div class="col-md-6" [hidden]="!isChecked">
          <mat-form-field [color]="param.color" appearance="outline">
            <mat-label>
              Si vous nécessitez un aménagement au regard de votre handicap, nous vous invitons si vous le souhaitez, à nous en faire part
            </mat-label>
            <textarea [(ngModel)]="description2" (ngModelChange)="onSave('can_handicap_amenagement', $event)" type="text" rows="5" cols="40" matInput maxlength="1000" name="description2"></textarea>
          </mat-form-field>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Profil">
      <div class="row" style="margin-top:2rem;">
        <div class="col-md-6" *ngIf="isAffich('experience_nb')">
          <mat-form-field [color]="param.color">
            <mat-label>Nombre d'années d'experience</mat-label>
            <input type="number" min="0" [(ngModel)]="_profil_experience" matInput id="experience_nb" name="experience_nb" placeholder="0 pour les débutants" (ngModelChange)="onSave('profil_experience', $event)" #experience>
            <!--<button id="edit-exp" mat-icon-button matSuffix (click)="onClick($event);" *ngIf="selected !== 'edit-exp'">
              <div class="icon"><mat-icon>edit</mat-icon></div>
            </button>
            <button id="valid-exp" mat-icon-button matSuffix *ngIf="selected == 'edit-exp'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
            <button id="clear-exp" mat-icon-button (click)="onClear()" matSuffix *ngIf="selected == 'edit-exp'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
          </mat-form-field>
        </div>
        <!--<div class="col-md-6" *ngIf="isAffich('experience')">
          <mat-form-field [color]="param.color" appearance="legacy">
            <mat-label>Experiences</mat-label>
            <mat-select (ngModelChange)="onSubmitField()" panelClass="example-panel-{{param.color}}" [(ngModel)]="experienceModel" id="experience" name="experience">
              <mat-option *ngFor="let experiences of experienceName" [value]="experiences">{{experiences.experience}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>-->
      </div>

      <div class="row">
        <div class="col-md-6" *ngIf="isAffich('remu_actu')">
          <mat-form-field [color]="param.color">
            <mat-label>Rémunération actuelle (Ex. 20.000€ par an = 20k€ /an)</mat-label>
            <input type="number" min="0" [(ngModel)]="_remuactu" matInput id="remu_actu" name="remu_actu" placeholder="€ k/an" (ngModelChange)="onSave('profil_salaire', $event)" #remuactu>
            <!--<button id="edit-_remuactu" mat-icon-button matSuffix (click)="onClick($event);" *ngIf="selected !== 'edit-_remuactu'">
              <div class="icon"><mat-icon>edit</mat-icon></div>
            </button>
            <button id="valid-_remuactu" mat-icon-button matSuffix *ngIf="selected == 'edit-_remuactu'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
            <button id="clear-_remuactu" mat-icon-button (click)="onClear()" matSuffix *ngIf="selected == 'edit-_remuactu'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
          </mat-form-field>
        </div>
        <div class="col-md-6" *ngIf="isAffich('situation')">
          <mat-form-field [color]="param.color" appearance="legacy">
            <mat-label>Situation actuelle</mat-label>
            <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="_situation" (ngModelChange)="onSave('profil_enposte', $event)" id="situation" name="situation">
              <mat-option *ngFor="let situation of situations" [value]="situation.situation">{{situation.situation}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6" *ngIf="isAffich('formation')">
          <mat-form-field [color]="param.color" appearance="legacy">
            <mat-label>Niveau d'études'</mat-label>
            <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="_etude" (ngModelChange)="onSave('profil_etude', $event)" id="formation" name="formation">
              <mat-option *ngFor="let formations of formationName" [value]="formations.niveau_formation">{{formations.niveau_formation}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-6" *ngIf="isAffich('domaine')">
          <mat-form-field [color]="param.color">
            <mat-label>Domaine de formation</mat-label>
            <input type="text" [(ngModel)]="_precisezFormation" matInput id="domaine" name="domaine" placeholder="" (ngModelChange)="onSave('profil_precisez_formation', $event)" #domaine>
            <!--<button id="edit-formation" mat-icon-button matSuffix (click)="onClick($event);" *ngIf="selected !== 'edit-formation'">
              <div class="icon"><mat-icon>edit</mat-icon></div>
            </button>
            <button id="valid-formation" mat-icon-button matSuffix *ngIf="selected == 'edit-formation'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
            <button id="clear-formation" mat-icon-button (click)="onClear();" matSuffix *ngIf="selected == 'edit-formation'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <mat-form-field [color]="param.color" appearance="legacy">
            <mat-label>Type d'établissement</mat-label>
            <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="_etablissement" (ngModelChange)="onSave('profil_etablissement', $event)" id="etablissement" name="etablissement">
              <mat-option *ngFor="let etablissements of profilEtablissement" [value]="etablissements.etablissement">{{etablissements.etablissement}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field [color]="param.color">
            <mat-label>Précisez Etablissement</mat-label>
            <input type="text" [(ngModel)]="_precisezEtablissement" matInput id="precisez_etablissement" name="precisez_etablissement" placeholder="" (ngModelChange)="onSave('profil_precisez_etablissement', $event)" #domaine>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" *ngIf="isAffich('langues')">
          <form [formGroup]="patientCategory">
            <mat-form-field [color]="param.color">
              <mat-label>Langues</mat-label>
              <mat-select formControlName="skalls" [compareWith]="compareObjects" (ngModelChange)="onSave('langues', $event)" panelClass="example-panel-{{param.color}}" multiple>
                <mat-option *ngFor="let langue of langues" [hidden]="langue.idcompetence_langue == 0" [value]="{ Id : langue.idcompetence_langue, Name : langue.competence_langue_nom, Niveau: 0, Hover: 0}">{{langue.competence_langue_nom}}</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
          <div class="col-md-6 mb-2">
            <div class="row mb-2" *ngFor="let langue of skills">
              <div class="col-4"><b>{{ langue.Name }}</b></div>
              <div class="col-8">
                <div class="row">
                  <span *ngFor="let nvlg of niveauLangue"
                        [hidden]="nvlg.idniveau == 0"
                        (mouseenter)="langue.Hover = nvlg.idniveau"
                        (mouseleave)="langue.Hover = 0"
                        (click)="langue.Niveau = nvlg.idniveau;onSave('nivLangue', langue)"
                        class="rating-container"
                        style="cursor: pointer;"
                        [matTooltip]="nvlg.niveau"
                        matTooltipPosition="above"
                        matTooltipClass="example-tooltip-red">
                    <span [class]=" langue.Niveau >= nvlg.idniveau || langue.Hover >= nvlg.idniveau ? 'star-selected' : 'star' ">
                      &#9733;
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Projet">
      <div class="col-md-12" style="margin-top:2rem;">
        <div class="row">
          <div class="col-md-6" *ngIf="isAffich('disponibilite')">
            <mat-form-field [color]="param.color" appearance="legacy">
              <mat-label>Disponibilité</mat-label>
              <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="_dispo" id="disponibilite" name="disponibilite" (ngModelChange)="onSave('profil_dispo', $event)">
                <mat-option *ngFor="let dispo of dispos" [value]="dispo.disponibilite">{{dispo.disponibilite}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6" *ngIf="isAffich('datedispo')">
            <mat-form-field [color]="param.color">
              <mat-label>Date de disponibilité</mat-label>
              <input matInput [matDatepicker]="picker" name="datedispo" [(ngModel)]="_datedispo" (ngModelChange)="onSave('profil_date_dispo', $event)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <!--<input type="text" matInput value="{{ _fixe }}" name="domicile" [(ngModel)]='_fixe' placeholder="0102030405" [readonly]="!editMode4" #fixe>-->
              <!--<button id="edit-datedispo" mat-icon-button matSuffix (click)="onClick($event);lastValue=_datedispo.toString()" *ngIf="selected !== 'edit-datedispo'"><div class="icon"><mat-icon>edit</mat-icon></div></button>
              <button id="valid-datedispo" mat-icon-button matSuffix *ngIf="selected == 'edit-datedispo'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
              <button id="clear-datedispo" mat-icon-button (click)="onClear();lastDatedispo();" matSuffix *ngIf="selected == 'edit-datedispo'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field [color]="param.color">
              <mat-label>Poste visé</mat-label>
              <input type="text" matInput id="poste" [(ngModel)]="_poste" name="poste" placeholder="" (ngModelChange)="onSave('profil_titre', $event)" #poste>
              <!--<button id="edit-poste" mat-icon-button matSuffix (click)="onClick($event);" *ngIf="selected !== 'edit-poste'">
                <div class="icon"><mat-icon>edit</mat-icon></div>
              </button>
              <button id="valid-poste" mat-icon-button matSuffix *ngIf="selected == 'edit-poste'" (click)="onSubmitField()"><div class="icon"><mat-icon>done</mat-icon></div></button>
              <button id="clear-poste" mat-icon-button (click)="onClear();" matSuffix *ngIf="selected == 'edit-poste'"><div class="icon"><mat-icon>clear</mat-icon></div></button>-->
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <p>
              <mat-form-field [color]="param.color" appearance="legacy">
                <mat-label>Types de contrats</mat-label>
                <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="ContratName" (ngModelChange)="onSave('contrats', $event)" name="poste" multiple>
                  <mat-option *ngFor="let poste of posteContrat" [value]="poste.idtype_contrat">{{poste.contrat}}</mat-option>
                </mat-select>
              </mat-form-field>
            </p>
          </div>
          <div class="col-md-6">
            <mat-form-field [color]="param.color" appearance="legacy">
              <mat-label>Fonctions</mat-label>
              <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="fonctionName" (ngModelChange)="onSave('fonctions', $event)" name="fonction" multiple>
                <mat-option *ngFor="let fonction of emploiFonction" [value]="fonction.idfonction">{{fonction.fonction}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <p>
              <mat-form-field [color]="param.color" appearance="legacy">
                <mat-label>Localisation du poste souhaitée </mat-label>
                <mat-select panelClass="example-panel-{{param.color}}" [(ngModel)]="regionName" (ngModelChange)="onSave('regions', $event)" name="region" multiple>
                  <mat-option *ngFor="let regions of region" [value]="regions.idregion">{{regions.region}}</mat-option>
                </mat-select>
              </mat-form-field>
            </p>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-12">
                <mat-label>Salaire souhaité entre (K € brut/an | Ex. 20.000€ par an = 20k€ /an)</mat-label>
              </div>
              <div class="col-6">
                <mat-form-field [color]="param.color" appearance="outline">
                  <input [(ngModel)]="_salaireMin" (ngModelChange)="onSave('profil_salaire_inf', $event)" matInput pattern="^[0-9]*$" placeholder="Salaire min" #salairemin>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field [color]="param.color" appearance="outline">
                  <input [(ngModel)]="_salaireMax" (ngModelChange)="onSave('profil_salaire_sup', $event)" matInput pattern="^[0-9]*$" placeholder="Salaire max" #salairemax>
                </mat-form-field>
              </div>
            </div>


          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Expériences">
      <div class="row" style="margin-top:2rem;">
        <div class="col-4">
          <input type="button" (click)="openDialogAdd()" [disabled]="profilExpTab.length >= 3" class="btn btn-next btn-fill btn-rose btn-wd" value="Ajouter une expérience">
        </div>
      </div>
      <div class="row justify-content-between" style="margin-top:2rem;">
        <div *ngFor="let profExp of profilExpTab" class="col-md-3">
          <mat-card style="margin-right: 2rem;box-shadow: 2px 2px 1px 2px rgba(0, 0, 0, 0.2), 0px 1px 1px 2px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;">
            <mat-card-header>
              <mat-card-title style="color: #000000">{{profExp.profil_exp_intitule}} - {{profExp.profil_exp_societe}}</mat-card-title>
              <mat-card-subtitle *ngIf="profExp.profil_exp_secteur || profExp.profil_exp_fonction">{{profExp.profil_exp_fonction}} - {{profExp.profil_exp_secteur}}</mat-card-subtitle>
              <mat-card-subtitle *ngIf="profExp.profil_exp_niveau">{{profExp.profil_exp_niveau}}</mat-card-subtitle>
            </mat-card-header>
            <!--<img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu">-->
            <mat-card-content>
              <strong *ngIf="profExp.profil_exp_descrip">Description du poste :</strong>
              <br />
              <br />
              <p *ngIf="profExp.profil_exp_descrip">{{profExp.profil_exp_descrip}}</p>
              <br *ngIf="!profExp.profil_exp_descrip" />
              <br />
              <strong *ngIf="profExp.profil_exp_comp1 || profExp.profil_exp_comp2 || profExp.profil_exp_comp3">Compétences :</strong>
              <br />
              <br />
              <ul *ngIf="profExp.profil_exp_comp1 || profExp.profil_exp_comp2 || profExp.profil_exp_comp3">
                <li *ngIf="profExp.profil_exp_comp1">{{profExp.profil_exp_comp1}}</li>
                <li *ngIf="profExp.profil_exp_comp2">{{profExp.profil_exp_comp2}}</li>
                <li *ngIf="profExp.profil_exp_comp3">{{profExp.profil_exp_comp3}}</li>
              </ul>
              <br *ngIf="!profExp.profil_exp_comp1 && !profExp.profil_exp_comp2 && !profExp.profil_exp_comp3" />
              <br *ngIf="!profExp.profil_exp_comp1 && !profExp.profil_exp_comp2 && !profExp.profil_exp_comp3" />
            </mat-card-content>
            <mat-card-actions class="text-center">
              <input type="button"
                     (click)="openDialogEdit(profExp)"
                     class="btn btn-next btn-fill btn-rose btn-wd"
                     value="MODIFIER"
                     style="margin-right:1rem;">
              <input type="button"
                     (click)="onDelete(profExp.idprofil_exp)"
                     class="btn btn-next btn-fill btn-rose btn-wd"
                     value="SUPPRIMER">
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
      <br />
    </mat-tab>
  </mat-tab-group>
</div>
